// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function dominicanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'do',
    document: userInputValues['dominicanDocument'],
    zipcode: userInputValues['dominicanZipcode'],
    state: userInputValues['dominicanState'],
    city: userInputValues['dominicanCity'],
    address: userInputValues['dominicanAddress'],
    street_number: userInputValues['dominicanStreetNumber'],
    street_complement: userInputValues['dominicanStreetComplement'],
    phone_number: userInputValues['dominicanPhoneNumber'],
  };
}
